<template>
  <div>
    <v-card class="mx-auto pa-6 rounded-lg">
      <b>{{ $t("policyForm.select") }}</b> <br /><br />
      <p>{{ $t("template.text16") }}</p>
      <v-radio-group v-model="contentSelect" row>
        <v-radio
          color="#077893"
          :label="$t('template.text17')"
          value="subject"
        ></v-radio>
        <v-radio
          color="#077893"
          :label="$t('template.text18')"
          value="body"
        ></v-radio>
      </v-radio-group>
      <p>{{ $t("template.text19") }}</p>
      <v-select
        v-if="contentSelect === 'subject'"
        color="#077893"
        dense
        outlined
        item-text="Text"
        item-value="Value"
        :label="$t('template.text17')"
        v-model="SelectSeller"
        :items="$t('email.itemsConsentHeader')"
        @input="fn_selector(SelectSeller)"
      ></v-select>
      <v-select
        v-if="contentSelect === 'body'"
        color="#077893"
        dense
        outlined
        item-text="Text"
        item-value="Value"
        :label="$t('template.text18')"
        v-model="SelectSeller"
        :items="$t('email.itemsConsentDetail')"
        @input="fn_selector(SelectSeller)"
      ></v-select>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  components: {},
  data: function () {
    return {
      contentSelect: 'body',
      SelectSeller: '',
      SelectBuyer: '',
      SelectDocument: '',
      LoadingCheck: ''
    }
  },
  computed: {
    ...mapGetters(['Business'])
  },
  methods: {
    fn_selector (value) {
      var payload = {
        content: this.contentSelect,
        key: value
      }
      this.$emit('fn_selector', payload)
    }
  }
}
</script>

<style scoped>
.special-text {
  /* background-color: rgb(9, 53, 73); */
  border: 2px solid rgb(9, 53, 73);
  width: 250px;
  height: 100px;
  display: flex;
  color: black;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}

.bg-color {
  background-color: #ddf7ff;
}
</style>

<style>
body {
  overflow: hidden !important;
}
</style>
